module.exports = __webpack_public_path__ + "static/media/flow.952e9477.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/flow.png
// module id = 60
// module chunks = 0